/**
 * soleil-toast.js — transient toast notices (Soleil "moment" UI, Component 8).
 *
 * Event-driven + self-contained (no GSAP/Alpine dependency; motion is CSS via the
 * .soleil-toast--in class). Trigger a toast from anywhere:
 *
 *   document.dispatchEvent(new CustomEvent('soleil:toast', {
 *     detail: { message: 'Adicionado à sacola', type: 'success', duration: 4000 }
 *   }));
 *
 * type: 'success' (lime) | 'info' (skyblue) | 'warning' (rose) | omitted (cream).
 *
 * NO cart coupling — this is the notification layer only. Which moments actually
 * fire a toast (added-to-bag, free-shipping, low-stock) is wired separately and
 * is a deferred decision (see docs/RUNTIME_QA_PENDING.md, Component 8).
 */
(function () {
  'use strict';

  var container = null;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EXIT_MS = reduce ? 0 : 240; // ~ --soleil-motion-base, time for the exit transition

  function ensureContainer() {
    if (container && document.body.contains(container)) return container;
    container = document.createElement('div');
    container.className = 'soleil-toasts';
    container.setAttribute('role', 'status');
    container.setAttribute('aria-live', 'polite');
    document.body.appendChild(container);
    return container;
  }

  function show(detail) {
    if (!detail || !detail.message) return;
    var c = ensureContainer();

    var toast = document.createElement('div');
    toast.className = 'soleil-toast';
    if (detail.type) toast.className += ' soleil-toast--' + detail.type;
    toast.textContent = detail.message;
    c.appendChild(toast);

    // Enter on the next frame so the CSS transition runs from the hidden state.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { toast.classList.add('soleil-toast--in'); });
    });

    var duration = typeof detail.duration === 'number' ? detail.duration : 4000;
    setTimeout(function () {
      toast.classList.remove('soleil-toast--in');
      setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
        if (c.childElementCount === 0 && c.parentNode) {
          c.parentNode.removeChild(c);
          container = null;
        }
      }, EXIT_MS);
    }, duration);
  }

  document.addEventListener('soleil:toast', function (e) { show(e.detail); });
})();
